import { createRouter, createWebHistory } from 'vue-router'

// 创建路由实例

export const constantRoutes = [
  { path: '/', name: 'Home', component: () => import('@/views/Home.vue') },
  { path: '/about', name: 'About', component: () => import('@/views/About.vue') },
  {
    path: '/product',
    name: 'Product',

    children: [
       {
        path: '',
        name: 'Index',
        component: () => import('@/views/product/Index.vue')
      },
      {
        path: 'operation',
        name: 'ProductOperation',
        component: () => import('@/views/product/Operation.vue')
      },
      {
        path: 'development',
        name: 'ProductDevelopment',
        component: () => import('@/views/product/Development.vue')
      }
    ]
  },
  {
    path: '/promotion',
    name: 'Promotion',
    component: () => import('@/views/promotion/Index.vue'),
    children: [
      {
        path: 'wechat-operation',
        name: 'WechatOperation',
        component: () => import('@/views/promotion/WechatOperation.vue')
      },
      {
        path: 'xiaohongshu-operation',
        name: 'XiaohongshuOperation',
        component: () => import('@/views/promotion/XiaohongshuOperation.vue')
      },
      {
        path: 'video-operation',
        name: 'VideoOperation',
        component: () => import('@/views/promotion/VideoOperation.vue')
      },
      {
        path: 'media-promotion',
        name: 'MediaPromotion',
        component: () => import('@/views/promotion/MediaPromotion.vue')
      },
      {
        path: 'advertising',
        name: 'Advertising',
        component: () => import('@/views/promotion/Advertising.vue')
      },
      {
        path: 'publishing-service',
        name: 'PublishingService',
        component: () => import('@/views/promotion/PublishingService.vue')
      },
      {
        path: 'brand-visual-design',
        name: 'BrandVisualDesign',
        component: () => import('@/views/promotion/BrandVisualDesign.vue')
      },
      {
        path: 'graphic-design',
        name: 'GraphicDesign',
        component: () => import('@/views/promotion/GraphicDesign.vue')
      },
      {
        path: 'video-production',
        name: 'VideoProduction',
        component: () => import('@/views/promotion/VideoProduction.vue')
      },
      {
        path: 'material-production',
        name: 'MaterialProduction',
        component: () => import('@/views/promotion/MaterialProduction.vue')
      },
      {
        path: 'event-planning',
        name: 'EventPlanning',
        component: () => import('@/views/promotion/EventPlanning.vue')
      },
      {
        path: 'editing-service',
        name: 'EditingService',
        component: () => import('@/views/promotion/EditingService.vue')
      }
    ]
  },
  { path: '/contact', name: 'Contact', component: () => import('@/views/Contact.vue') },
  { path: '/login', name: 'Login', component: () => import('@/views/Login.vue') },
  { path: '/case', name: 'Case', component: () => import('@/views/case/Case.vue') }
]
const router = createRouter({
  history: createWebHistory(import.meta.env.VITE_BASE_URL),
  routes: constantRoutes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { top: 0 };
    }
  },
});

export default router